import { render, staticRenderFns } from "./ListDocuments.vue?vue&type=template&id=74e35ca2&scoped=true"
import script from "./ListDocuments.vue?vue&type=script&lang=js"
export * from "./ListDocuments.vue?vue&type=script&lang=js"
import style0 from "./ListDocuments.vue?vue&type=style&index=0&id=74e35ca2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e35ca2",
  null
  
)

export default component.exports